import { Location } from "@angular/common";
import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot,
} from "@angular/router";
import { AccountPlan, ApiGateway, PageOptions } from "cw-backend";
import { CwUtils } from "cw-utils";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class AccountPlanListProvider implements Resolve<any> {
    accountPlan: AccountPlan[];
    accountPlanEdit: AccountPlan;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.accountPlanEdit = this.state?.currentAccountPlan;

        if (this.currentPage) {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "code";
        } else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = "code";
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getPage(this.pageOptions)]).then(() => {
                resolve();
            }, reject);
        });
    }

    get(id: number): Observable<AccountPlan> {
        if (!id) {
            return null;
        }
        return this.gw.get("accountPlan/:id", { id: id });
    }

    get currentAccountPlan(): AccountPlan {
        return this.accountPlanEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get("accountPlan/").subscribe((res: HttpResponse<any>) => {
                this.accountPlan = res.body;
                resolve(res);
            }, reject);
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post("accountPlan/search", pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    if (
                        !CwUtils.compare(this.accountPlan, res.body.content) &&
                        res.body.content.length > 0
                    ) {
                        this.accountPlan = res.body.content;
                        this.onDataChanged.next(this.accountPlan);
                    } else {
                        this.accountPlan = res.body.content;
                    }
                    resolve(res);
                }, reject);
        });
    }

    getParentPage(pageOptions: PageOptions, parentId: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`accountPlan/search/${parentId}`, pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getParentIsNotNullPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`accountPlan/search/parent`, pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getAccountPlanType(type: string, pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`accountPlan/search/parent/${type}`, pageOptions)
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }

    getCompanyAccountPlanPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`accountPlan/companyAccountPlan/search`, pageOptions)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }

    getCompanyPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post(`accountPlan/company/search`, pageOptions).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                },
            });
        });
    }

    getCompanyPageByAccountPlanId(
        pageOptions: PageOptions,
        id: number,
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw
                .post(`accountPlan/companyAccountPlan/${id}`, pageOptions)
                .subscribe({
                    next: (res: HttpResponse<any>) => {
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    },
                });
        });
    }
}
